import React, { useState, useEffect, useRef } from 'react'
import { Modal, Spinner } from 'react-bootstrap'

import { doReTweet, doTweetForSuccess } from 'apis/twitter'
import { useLocation, useNavigate } from 'react-router-dom'
import useKeycloakFeatures from 'keycloak/useKeycloakFeatures'
import {
  getCurrentActiveRiddle,
  getUserRiddleInformation,
  getUserRiddleSuccessStatusInformation,
  verifyMissingRiddleSucccess
} from 'apis/founderApis'
import Tweet from 'components/tweetEmbed/Tweet'
import { openCrib } from 'constant/constant'
import { TwitterRoles } from 'utils/consts'
import { decodeBase64 } from 'utils/helpers'
import { doTwitterLinkingLogin, getUserInfoAccessToken } from 'apis/twitterLinking'
import ModalMessage from 'components/modals/ModalMessage'

const ShowType = {
  TYPE_SHARE: 'TYPE_SHARE',
  TYPE_RETWEET: 'TYPE_RETWEET',
  TYPE_ENTER_CRIB: 'TYPE_ENTER_CRIB',
  TYPE_RETWEET_ERROR: 'TYPE_RETWEET_ERROR',
  TYPE_SHARE_SUCCESS: 'TYPE_SHARE_SUCCESS',
  TYPE_SHARE_ERROR: 'TYPE_SHARE_ERROR'
}

const TWITTER_INTENT_URL = 'https://twitter.com/intent/tweet?text='

const RetweetControllerComponent = (props) => {
  const [showModal, setIshowModal] = useState(null)
  const [tweetResponce, setTweetResponce] = useState(null)
  const [shareRiddleResponce, setShareRiddleResponce] = useState(null)

  const [messageToUser, setMessageToUser] = useState(null)
  const [isShowProgress, setShowProgress] = useState(false)

  const [twitterData, setTwitterData] = useState(null)
  const refSrcRef = useRef()
  const refTweetRole = useRef()
  const refGameInfoRef = useRef()
  const navigate = useNavigate()
  const { doLogin, keyCloakUser } = useKeycloakFeatures()
  const searchParams = useLocation()

  const shareTweetBtnRef = useRef(false);

  function openInNewTab(url) {
    window.open(url, '_blank')
  }


  function getTagsAndTxt(tweet) {
    const splittedData = tweet.split('#')

    if (splittedData.length > 1) {
      const msg = splittedData[0]
      splittedData.splice(0, 1)
      const tags = splittedData.join(',')
      return [msg, tags]
    }
    return [tweet, '']
  }

  async function tweetSuccess() {
    const { accessToken, shareMessage, riddleDocID } = twitterData

    if(shareTweetBtnRef.current) return;

    shareTweetBtnRef.current = true;

    const tweetRes = await doTweetForSuccess(
      '',
      accessToken,
      shareMessage ?? '#',
      '',
      riddleDocID,
      keyCloakUser.accessToken
    )

    setTimeout(()=>{
      shareTweetBtnRef.current = false;
    },3000)


    const [txt, tags] = getTagsAndTxt(shareMessage)

    if (tweetRes.success) {
      setShareRiddleResponce(tweetRes)
      setIshowModal(ShowType.TYPE_SHARE_SUCCESS)
      openInNewTab(`${TWITTER_INTENT_URL}${txt}&hashtags=${tags}`)
    }
  }

  const handleUserRiddleReTweetStatus = async (isDiractEnterCrib) => {
    setShowProgress(true)
    try {
      const gameInfo = await getUserRiddleInformation(refSrcRef.current, keyCloakUser.accessToken)
      if (gameInfo.success == true && gameInfo?.action?.length > 0) {
        refGameInfoRef.current = gameInfo

        if (isDiractEnterCrib) {
          openCrib(
            refSrcRef.current,
            keyCloakUser?.accessToken ?? '',
            refGameInfoRef.current?.gameInfo?.build_link
          )
          resetData()
          navigate('/')
        } else {
          setTweetResponce({
            success: true,
            message: 'You can now enter the crib.',
            title: 'Success!'
          })
          setIshowModal(ShowType.TYPE_ENTER_CRIB)
        }
      } else if (gameInfo.success == true && gameInfo.riddleInfo !== null) {
        refGameInfoRef.current = gameInfo
        setIshowModal(ShowType.TYPE_RETWEET)
      } else if (gameInfo.success == false && gameInfo.message) {
        refGameInfoRef.current = gameInfo
        setTweetResponce({ success: false, message: gameInfo.message })
        setIshowModal(ShowType.TYPE_RETWEET_ERROR)
      } else {
        navigate('/')
      }
    } catch (error) {}
    setShowProgress(false)
  }
  const handleUserRiddleSucccessShareStatus = async () => {
    setShowProgress(true)

    verifyMissingRiddleSucccess(refSrcRef.current, keyCloakUser.accessToken)
    try {
      const riddleShareStatusRes = await getUserRiddleSuccessStatusInformation(
        refSrcRef.current,
        keyCloakUser.accessToken
      )

      if (riddleShareStatusRes.success == true && riddleShareStatusRes?.action == null) {
        refGameInfoRef.current = riddleShareStatusRes
        const riddleInfo = riddleShareStatusRes.riddleInfo

        setTwitterData({
          twitterId: '',
          accessToken: keyCloakUser.accessToken,
          shareMessage: riddleInfo?.share_message ?? '#',
          userId: '',
          riddleDocID: riddleInfo?.riddle_doc_id,
          accessToken: keyCloakUser.accessToken
        })
        setIshowModal(ShowType.TYPE_SHARE)
      } else {
        const otherMsg =
          riddleShareStatusRes?.action !== null &&
          riddleShareStatusRes?.riddleInfo?.riddle_success_tweet_score
            ? `You have already earned ${
                riddleShareStatusRes?.riddleInfo?.riddle_success_tweet_score ?? 10
              } Founder's Points for current riddle.`
            : 'Failed to post Tweet!'
        setShareRiddleResponce({
          success: false,
          message: riddleShareStatusRes?.message ?? otherMsg
        })
        setIshowModal(ShowType.TYPE_SHARE_ERROR)
      }
    } catch (error) {}
    setShowProgress(false)
  }

  const enterCrib = () => {
    if (keyCloakUser) {
      setShowProgress(true)
      getCurrentActiveRiddle(keyCloakUser?.accessToken)
        .then((riddle) => {
          setShowProgress(false)
          if (riddle.success) {
            setMessageToUser(null)
            navigate(`/?riddle=${riddle.riddleInfo?.riddle_doc_id ?? ''}&_ec=${Math.random()}`, {
              replace: true
            })
          } else if (riddle.message) {
            setMessageToUser(riddle.message)
            navigate(`/`)
          }
        })
        .catch((error) => {
          setShowProgress(false)
          navigate(`/`)
          // console.log('getCurrentActiveRiddle error-->>', error)
        })
    } else {
      let url = new URL(window.location.origin)
      url.searchParams.append('_ec', Math.random())
      doLogin({ redirectUri: url })
    }
  }
  const handleTweetClick = (is_sso, twitterRole) => {
    if (keyCloakUser == null || keyCloakUser.id == null) {
      let url = new URL(window.location.href)
      url.searchParams.append('is_sso', true)
      url.searchParams.append('twitter_role', twitterRole)
      doLogin({ redirectUri: url })
    } else if (
      (keyCloakUser == null || keyCloakUser.id == null) &&
      (is_sso == null || is_sso == undefined || is_sso == false)
    ) {
      let url = new URL(window.location.href)
      url.searchParams.append('is_sso', true)
      url.searchParams.append('twitter_role', twitterRole)
      doLogin({ redirectUri: url })
    } else {
      // doTwitterLogin(refSrcRef.current, twitterRole, keyCloakUser?.accessToken)
      doTwitterLinkingLogin(refSrcRef.current, twitterRole, keyCloakUser?.accessToken)
      setIshowModal(null)
    }
  }
  const handleCancel = () => {
    if (tweetResponce?.success == true) {
      openCrib(
        refSrcRef.current,
        keyCloakUser?.accessToken ?? '',
        refGameInfoRef.current?.gameInfo?.build_link
      )
    }
    resetData()
    navigate('/')
  }
  const shareTweet = async (code, riddleDoc, rediract_data) => {
    setShowProgress(true)
    try {
      const userInfo = await getUserInfoAccessToken(
        code,
        riddleDoc,
        keyCloakUser.accessToken,
        rediract_data
      )
      if (userInfo?.access_token !== null) {
        const gameInfo = await getUserRiddleSuccessStatusInformation(
          riddleDoc,
          keyCloakUser.accessToken
        )
        refGameInfoRef.current = gameInfo
        const tweetResponccec = await doTweetForSuccess(
          '',
          userInfo?.access_token,
          gameInfo?.riddleInfo?.share_message ?? '#',
          userInfo?.id,
          gameInfo?.riddleInfo?.riddle_doc_id,
          keyCloakUser.accessToken,
          gameInfo?.riddleInfo?.game_id
        )
        //console.log('tweetResponccec-->', tweetResponccec)
        if (tweetResponccec.success == true) {
        }
        setShareRiddleResponce(tweetResponccec)
        setShowProgress(false)
        setIshowModal(ShowType.TYPE_SHARE_SUCCESS)
        navigate('/')
        return
      }
      throw 0
    } catch (error) {
      console.log('errorLL', error)
      setShareRiddleResponce({ success: false, message: 'Failed to post Tweet!' })
      setIshowModal(ShowType.TYPE_SHARE_ERROR)
      navigate('/')
    }

    setShowProgress(false)
  }
  const postReTweet = async (code, riddleDoc, rediract_data) => {
    setShowProgress(true)
    try {
      const userInfo = await getUserInfoAccessToken(
        code,
        riddleDoc,
        keyCloakUser.accessToken,
        rediract_data
      )
      if (userInfo?.access_token !== null) {
        const gameInfo = await getUserRiddleInformation(riddleDoc, keyCloakUser.accessToken)
        refGameInfoRef.current = gameInfo
        const tweetResponccec = await doReTweet(
          gameInfo?.riddleInfo?.tweet_id,
          userInfo?.access_token,
          gameInfo?.riddleInfo?.message,
          userInfo?.id,
          gameInfo?.riddleInfo?.riddle_doc_id,
          keyCloakUser.accessToken,
          gameInfo?.riddleInfo?.game_id
        )
        setTweetResponce(tweetResponccec)
        setShowProgress(false)
        setIshowModal(ShowType.TYPE_ENTER_CRIB)
        navigate('/')
        return
      }
      throw 0
    } catch (error) {
      setTweetResponce({ success: false, message: 'Failed to post Tweet!' })
      setIshowModal(ShowType.TYPE_RETWEET_ERROR)
      navigate('/')
    }

    setShowProgress(false)
  }

  useEffect(() => {
    const params = new URLSearchParams(searchParams.search)
    const riddle = params.get('riddle')
    const code = params.get('code')
    const is_sso = params.get('is_sso')
    const share_riddle = params.get('share_riddle')
    const enter_crib = params.get('_ec')
    if (code) {
      /* The case when user successfully authrise twitter */
      const rediract_data = params.get('rediract_data')
      const rediractDataObj = rediract_data ? JSON.parse(decodeBase64(rediract_data)) : null
      refSrcRef.current = rediractDataObj.riddle
      if (rediractDataObj.twitter_role == TwitterRoles.RETWEET_RIDDLE) {
        postReTweet(code, rediractDataObj.riddle, rediract_data)
      } else {
        shareTweet(code, rediractDataObj.riddle, rediract_data)
      }
    } else if (riddle) {
      /* The case when user click tweet for riddle with riddle doc id */

      refSrcRef.current = riddle
      refTweetRole.current = TwitterRoles.RETWEET_RIDDLE
      if (is_sso == true && keyCloakUser != null) {
        /* The case when user click do login with riddle doc id  */
        setShowProgress(true)
        setTimeout(() => {
          handleUserRiddleReTweetStatus(enter_crib)
        }, 2000)
      } else if (keyCloakUser != null) {
        /* The case when user click do already login riddle doc id  */
        handleUserRiddleReTweetStatus(enter_crib)
      } else {
        handleTweetClick(is_sso, TwitterRoles.RETWEET_RIDDLE)
      }
    } else if (share_riddle) {
      refSrcRef.current = share_riddle
      refTweetRole.current = TwitterRoles.SHARE_RIDDLE_SUCCESS

      if (is_sso == true && keyCloakUser != null) {
        setShowProgress(true)
        setTimeout(() => {
          handleUserRiddleSucccessShareStatus()
        }, 2000)
      } else if (keyCloakUser != null) {
        handleUserRiddleSucccessShareStatus()
      } else {
        handleTweetClick(is_sso, TwitterRoles.SHARE_RIDDLE_SUCCESS)
      }
    } else if (enter_crib) {
      enterCrib()
    } else {
      console.log('ref_src parameter not found in URL.')
    }
  }, [searchParams.search])

  const resetData = () => {
    refSrcRef.current = null
    refGameInfoRef.current = null
    setTweetResponce(null)
    setIshowModal(null)
    setShowProgress(false)
    setShareRiddleResponce(null)
    setMessageToUser(null)
  }
  return (
    <>
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="w-600"
        contentClassName="connect-wallet-modal"
        show={showModal !== null}
        centered
        onExit={() => {
          resetData()
          navigate('/')
        }}>
        <div className="inner-content text-center">
          {showModal == ShowType.TYPE_RETWEET ? (
            <div>
              <div className="modal-title text-center">
                <h3 className="title md text-capitalize mb-5">Twitter Connect</h3>
                <p className="mb-0">To get to the crib, please like and retweet</p>
              </div>

              <div className="tweetImg">
                {refGameInfoRef.current?.riddleInfo?.tweet_id && (
                  <Tweet tweetID={refGameInfoRef.current?.riddleInfo?.tweet_id} />
                )}
              </div>

              <div className="group-btns">
                <button className="custom-btn lg rounded" onClick={handleCancel}>
                  Cancel
                </button>
                <button
                  className="custom-btn purple lg rounded"
                  onClick={() => handleTweetClick(null, TwitterRoles.RETWEET_RIDDLE)}>
                  Let’s Go!
                </button>
              </div>
            </div>
          ) : showModal == ShowType.TYPE_SHARE ? (
            <div>
              <div className="modal-title text-center">
                <h3 className="title md text-capitalize mb-5">Twitter Connect</h3>
                <p className="mb-0">
                  Click on "Share" to share the tweet and earn{' '}
                  {refGameInfoRef.current?.riddleInfo?.riddle_success_tweet_score ?? 25} bonus
                  Founder's Points.
                </p>
              </div>

              <div className="tweetMsg">
                {refGameInfoRef.current?.riddleInfo?.share_message
                  ? refGameInfoRef.current?.riddleInfo?.share_message
                  : ''}
              </div>

              <div className="group-btns">
                <button className="custom-btn lg rounded" onClick={handleCancel}>
                  Cancel
                </button>
                <button className="custom-btn purple lg rounded"  onClick={tweetSuccess}>
                  Share
                </button>
              </div>
            </div>
          ) : showModal == ShowType.TYPE_SHARE_SUCCESS || showModal == ShowType.TYPE_SHARE_ERROR ? (
            <>
              <div className="modal-title text-center">
                <h3 className="title md text-capitalize mb-5">
                  {' '}
                  {shareRiddleResponce?.success == true ? 'Congratulations' : 'Failed!'}
                </h3>
                <p className="mb-0">
                  {shareRiddleResponce?.success == true
                    ? `You have successfully earned ${
                        refGameInfoRef.current?.riddleInfo?.riddle_success_tweet_score ?? 25
                      } Founder's Points.`
                    : shareRiddleResponce?.message ?? ''}
                </p>
              </div>

              <div className="modal-btn">
                <button className="custom-btn purple rounded lg " onClick={handleCancel}>
                  {'Ok'}
                </button>
              </div>
            </>
          ) : showModal == ShowType.TYPE_ENTER_CRIB || showModal == ShowType.TYPE_RETWEET_ERROR ? (
            <>
              <div className="modal-title text-center">
                <h3 className="title md text-capitalize mb-5">
                  {tweetResponce?.title ??
                    (tweetResponce?.success == true ? 'Success!' : 'Failed!')}
                </h3>
                <p className="mb-0">{tweetResponce?.message ?? ''}</p>
              </div>

              <div className="modal-btn">
                <button className="custom-btn purple rounded lg " onClick={handleCancel}>
                  {tweetResponce?.success == true ? 'Enter Crib' : 'Ok'}
                </button>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </Modal>

      {isShowProgress && (
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName="w-580"
          contentClassName="border-box top connect-wallet-modal"
          show={isShowProgress}
          centered
          onExit={() => {
            setShowProgress(false)
          }}>
          <div className="inner-content text-center">
            <Spinner animation="border" />
          </div>
        </Modal>
      )}
      <ModalMessage message={messageToUser} onOkPress={() => setMessageToUser(null)} />
    </>
  )
}

export default RetweetControllerComponent
